import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { LoadingService } from '@core/services/loading.service';
// import { LoadingService } from '@core/services/loading.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-z-users-details',
  templateUrl: './z-users-details.component.html',
  styleUrls: ['./z-users-details.component.scss']
})
export class ZUsersDetailsComponent implements OnInit {



lang: string = 'en';
      public currentPage = 1; 
   public categories : any
  public totalItems = 0;
public articleDetails: any;
public articleId: string; // Store article ID

  constructor( private apisService: ApisService,
          private route: ActivatedRoute,
         private loading : LoadingService,
        private toastr : ToastrService,
        private translate: TranslateService
      ) { }

ngOnInit(): void {
    this.lang = this.translate.currentLang || this.translate.getDefaultLang();

  const id = this.route.snapshot.paramMap.get('id');
  if (id) {
    this.articleId = id;
    this.getArticleDetails(this.articleId);
  }
  

} 

 

getArticleDetails(id: any) {
  this.apisService.usersDetails(id).subscribe({
    next: (res) => {
      this.articleDetails = res.data;
      console.log(this.articleDetails);
      this.loading.hide();
    },
    error: (err) => {
      console.log('error in fetching article details', err);
  this.translate.get(['MENU.DASHBOARD.ERROR', 'MENU.DASHBOARD.UNEXPECTED_ERROR']).subscribe(translations => {
    this.toastr.error(translations['MENU.DASHBOARD.UNEXPECTED_ERROR'], translations['MENU.DASHBOARD.ERROR']);
  });      this.loading.hide();
    }
  });
}

     /*----------  Handling image Error  ----------*/
  handleImageError(event) {
    event.target.src = 'assets/images/icons/logo.jpg';
  }
 


  /*----------  detele fake users  ----------*/
  // deleteFakeUser(id){
  //   this.apisService.deleteComments(id).subscribe({
  //     next: (res) => {
  //       this.toastr.success("Deleted Successfully", "Success")
  //     this.getArticleDetails(this.articleId);

  //     },
  //     error: (err) => {
  //       console.log('error in fetching', err)
  //       this.toastr.error("Something went wrong", "Error")
  //     }
  //   })
  // }
  
loadUserDetails(): void {
  // Dummy data
  this.articleDetails = {
    id: 1,
    name: 'Ahmed Mohamed',
    email: 'ahmed.mohamed@example.com',
    phone: '+20 101 234 5678',
    status: 'active',
    missed_prayers_count: 12,
    last_missed_prayer_date: new Date('2026-01-05'),
    created_at: new Date('2025-10-12')
  };
}

}
